import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WebphoneComponent } from './webphone/webphone.component';
import { WebphoneDialerComponent } from './webphone-dialer/webphone-dialer.component';
import { IncomingCallComponent } from './incoming-call/incoming-call.component';
import { ActiveCallComponent } from './active-call/active-call.component';
import { CallOutGoingComponent } from './call-outgoing/call-outgoing.component';
import { EtopPipesModule } from "../../../../../../libs/shared/pipes/etop-pipes.module";
import { MaterialModule } from '@etop/shared';
@NgModule({
  declarations: [
    WebphoneComponent,
    WebphoneDialerComponent,
    IncomingCallComponent,
    ActiveCallComponent,
    CallOutGoingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    EtopPipesModule,
    MaterialModule
],
  exports: [
    WebphoneComponent,
    WebphoneDialerComponent,
    IncomingCallComponent,
    ActiveCallComponent,
    CallOutGoingComponent
  ]
})
export class WebphoneModule { }

